<template>
  <svg
    alt="Coins"
    :width="size"
    :height="size"
    class="coin-icon"
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="32" fill="#fac90b" />
    <circle
      cx="32"
      cy="32"
      r="23"
      fill="none"
      stroke="#c89211"
      stroke-width="2"
      stroke-linecap="round"
      stroke-dasharray="0 4" />
    <circle cx="32" cy="32" r="21" fill="#d5a429" />
    <path
      d="M38 26a8 8 0 1 0 0 12"
      fill="none"
      stroke="#facb09"
      stroke-width="5"
      stroke-linecap="round" />
  </svg>
</template>

<script>
export default {
  name: 'CoinIcon',
  props: {
    size: { type: Number, default: 15 },
  },
}
</script>

<style>
.coin-icon {
  position: relative;
  top: 2px;
}
</style>
